import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/gift_card_redemption_records',
  component: Management,
  redirect: '/gift_card_redemption_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/gift_card_redemption_records/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listGiftCardRedemptionRecords
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/gift_card_redemption_records/ListTable'),
          meta: {
            auth: Auth.listGiftCardRedemptionRecords,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
